<template>
  <font-awesome-icon
    icon="arrow-down"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faArrowDown } from '@fortawesome/free-solid-svg-icons'

library.add(faArrowDown)

export default {
  name: 'CoozzyArrowDownIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-text-grey;
  }
</style>
